
document.addEventListener("DOMContentLoaded", () => {
  let buttons = document.querySelectorAll(".u-collapsible-toggle ");
  buttons.forEach(button => {
    button.addEventListener("click", () => {
      let item = button.closest(".u-collapsible-item "); 
      let content = item.querySelector(".u-collapsible-content ");

      if (item.classList.contains("active")) {
        item.classList.remove("active");
        content.style.maxHeight = 0;
      } else {
        item.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});
document.addEventListener("DOMContentLoaded", () => {
  let buttons = document.querySelectorAll(".u--newfaqs-toggle");
  buttons.forEach(button => {
    button.addEventListener("click", () => {
      let item = button.closest(".u--newfaqs-item"); 
      let content = item.querySelector(".u--newfaqs-content");

      if (item.classList.contains("active")) {
        item.classList.remove("active");
        content.style.maxHeight = 0;
      } else {
        item.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});

document.addEventListener('click', function(e) {
  const button = e.target.closest('.u-block-collapsible-toggle');
  if (!button) return;

  const item = button.closest('.u-block-collapsible-item');
  const content = item.querySelector('.u-block-collapsible-content');

  item.classList.toggle('active');

  if (item.classList.contains('active')) {
    content.style.maxHeight = content.scrollHeight + 'px';
  } else {
    content.style.maxHeight = null;
  }
});


  document.addEventListener('DOMContentLoaded', function () {
    initSimpleReviewSlider();
    document.addEventListener('shopify:section:load', initSimpleReviewSlider);
  });
  function initSimpleReviewSlider() {
    document.querySelectorAll('.myopacityreviews').forEach(function (el) {
      if (el.swiper) {
        el.swiper.destroy(true, true);
      }
      new Swiper(el, {
        slidesPerView: 2.7,
        spaceBetween: 20,
        speed: 600,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: el.querySelector('.opacityreviews-swiper-button-next'),
          prevEl: el.querySelector('.opacityreviews-swiper-button-prev'),
        },
        breakpoints: {
          1200: {
            slidesPerView: 3.7,
            centeredSlides: true,
          },
          1025: {
            slidesPerView: 2.7,
            centeredSlides: true,
          },
          768: {
            slidesPerView: 2,
            centeredSlides: true,
          },
          0: {
            slidesPerView: 1.2,
            centeredSlides: true,
          },
        },
      });
    });
  }



document.addEventListener('DOMContentLoaded', () => {

  const popup = document.getElementById('uVideoPopup');
  const popupInner = popup.querySelector('.u-video-popup-inner');
  let activeVideo;

  document.querySelectorAll('.u-circle-video-wrapper').forEach(item => {
    item.onclick = () => {
      const videoBox = item.closest('.u-circle-item')
                           .querySelector('[id^="video-"]');
      if (!videoBox) return;

      const video = videoBox.querySelector('video').cloneNode(true);
      video.currentTime = 0;

      popupInner.innerHTML = `
        <span class="u-close-popup">✕</span>
        <div class="u-video-popup-video"></div>
      `;

      popupInner.querySelector('.u-video-popup-video')
                .appendChild(video);

      popup.style.display = 'flex';
      setTimeout(() => video.play(), 100);

      activeVideo = video;

      popup.querySelector('.u-close-popup').onclick = closePopup;
    };
  });

  function closePopup() {
    popup.style.display = 'none';
    if (activeVideo) {
      activeVideo.pause();
      activeVideo.currentTime = 0;
    }
    popupInner.innerHTML = '';
  }

  popup.onclick = e => {
    if (e.target === popup) closePopup();
  };

});


function gredient() {
  var swiper = new Swiper('.u-ingre-swiper', {
    slidesPerView: 4,
    spaceBetween: 50,
    breakpoints: {
      0: {
        slidesPerView: 1.8,
        spaceBetween: 55,
        centeredSlides:true,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 100,
      },
    },
  });
}


  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.u-popup-swiper', {
      slidesPerView: 6,
      spaceBetween: 10,
      loop: true,
      speed: 3000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: { slidesPerView: 2 },
        480: { slidesPerView: 3 },
        768: { slidesPerView: 5 },
        1024: { slidesPerView: 6 },
      },
    });
  });

document.addEventListener('DOMContentLoaded', function () {

  const popup = document.getElementById('uReviewPopup');
  const closeBtn = document.querySelector('.u-popup-close');
  const openBtns = document.querySelectorAll('.open-review-popup');
  const overlay = document.querySelector('.u-popup-overlay');

  const popupSlider = new Swiper('.u-popup-content-slider', {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  function openPopup(index) {
    popup.style.display = 'block';
    document.body.classList.add('u-popup-open');
    popupSlider.slideToLoop(index);
  }

  function closePopup() {
    popup.style.display = 'none';
    document.body.classList.remove('u-popup-open');
  }

  openBtns.forEach((btn) => {
  btn.addEventListener('click', function () {
    const index = parseInt(this.dataset.slide, 10);
    openPopup(index);
  });
});

  closeBtn.addEventListener('click', closePopup);

  // ✅ ONLY overlay click closes popup
  overlay.addEventListener('click', closePopup);

popup.addEventListener('click', function (e) {

  const clickedInsideBox = e.target.closest('.u-popup-box');
  const clickedNav = e.target.closest('.swiper-button-next, .swiper-button-prev');
  const clickedClose = e.target.closest('.u-popup-close');

  if (!clickedInsideBox && !clickedNav && !clickedClose) {
    closePopup();
  }

});
});